import {Pipe, PipeTransform} from "@angular/core";
import {InvoiceCategory} from "../enums/invoice-category.enum";
@Pipe({
    name: "invoiceCategory",
    standalone: false
})
export class InvoiceCategoryPipe implements PipeTransform {
    constructor() { }

    transform(value?: number): string | void {
        if (typeof value === 'undefined' || value < 0) return;

        return InvoiceCategory[value];
    }
}